(() => {
  if (!/\/collections\//.test(location.pathname)) return;
  const labels = JSON.parse(document.getElementById('wfd-browse-labels').textContent);
  const container = document.getElementById('ProductGridContainer');
  if (!container) return;
  const $ = (selector, root = document) => root.querySelector(selector);
  let grid, pageData, pager, controls, modeControl, status, loadButton, autoLoadInput, sentinel;
  let currentPage = 1, firstPage = 1, nextUrl = '', signature = '';
  let generation = 0, request = null, observer = null, restoring = false, error = false;
  let autoLoad = true, autoScroll = false, frame = 0, lastTime = null, positionFrame = 0, scrollTarget = 0;
  const gridModals = new Set();
  let restoreCancelled = false;
  const storageGet = (key) => { try { return sessionStorage.getItem(key); } catch (_) { return null; } };
  const storageSet = (key, value) => { try { sessionStorage.setItem(key, value); } catch (_) {} };
  autoLoad = storageGet('wfd_auto_load') !== 'off';
  function urlSignature() {
    const url = new URL(location.href);
    url.searchParams.delete('section_id');
    url.hash = '';
    return url.pathname + url.search;
  }
  function collectionSignature(url) {
    const parsed = new URL(url, location.href);
    ['page', 'section_id', 'preview_theme_id', '_fd', 'pb'].forEach(key => parsed.searchParams.delete(key));
    ['filter.v.price.gte', 'filter.v.price.lte'].forEach(key => {
      if (parsed.searchParams.get(key) === '') parsed.searchParams.delete(key);
    });
    parsed.searchParams.sort();
    return parsed.pathname + parsed.search;
  }
  function makeButton(id, text) {
    const button = document.createElement('button');
    button.id = id;
    button.type = 'button';
    button.textContent = text;
    return button;
  }
  const scrollButton = makeButton('wfd-autoscroll', labels.auto_off);
  scrollButton.setAttribute('aria-pressed', 'false');
  const topButton = makeButton('wfd-back-to-top', labels.top);
  document.body.append(scrollButton, topButton);
  function stopScroll() {
    autoScroll = false;
    cancelAnimationFrame(frame);
    frame = 0;
    lastTime = null;
    scrollButton.textContent = labels.auto_off;
    scrollButton.setAttribute('aria-pressed', 'false');
  }
  function tick(time) {
    if (!autoScroll) return;
    const delta = lastTime === null ? 0 : Math.min(50, time - lastTime);
    lastTime = time;
    const bottom = document.documentElement.scrollHeight - innerHeight;
    if (scrollY >= bottom - 2) {
      if (request) { frame = requestAnimationFrame(tick); return; }
      stopScroll();
      return;
    }
    scrollTarget += 80 * delta / 1000;
    window.scrollTo({ top: scrollTarget, behavior: 'instant' });
    frame = requestAnimationFrame(tick);
  }
  scrollButton.addEventListener('click', () => {
    if (autoScroll) { stopScroll(); return; }
    autoScroll = true;
    lastTime = null;
    scrollTarget = scrollY;
    scrollButton.textContent = labels.auto_on;
    scrollButton.setAttribute('aria-pressed', 'true');
    frame = requestAnimationFrame(tick);
  });
  function interrupt(event) {
    if (event.target && scrollButton.contains(event.target)) return;
    stopScroll();
    restoreCancelled = true;
  }
  document.addEventListener('pointerdown', interrupt, { passive: true });
  document.addEventListener('touchstart', interrupt, { passive: true });
  document.addEventListener('wheel', interrupt, { passive: true });
  document.addEventListener('keydown', event => {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' ', 'Escape', 'Tab'].includes(event.key)) interrupt(event);
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) stopScroll(); });
  topButton.addEventListener('click', () => {
    stopScroll();
    window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  function positionButtons() {
    if (positionFrame) return;
    positionFrame = requestAnimationFrame(() => {
      positionFrame = 0;
      let obstruction = 0;
      document.querySelectorAll('[id*="wishlisthero"], [class*="wishlisthero"], [id*="wishlist-hero"], [class*="wishlist-hero"], .wishlist-floating, .wishlist-button').forEach(element => {
        const style = getComputedStyle(element);
        if (style.position !== 'fixed' || style.display === 'none' || style.visibility === 'hidden') return;
        const rect = element.getBoundingClientRect();
        if (rect.right > innerWidth - 40 && rect.bottom > innerHeight - 40) obstruction = Math.max(obstruction, innerHeight - rect.top + 14);
      });
      scrollButton.style.bottom = `${96 + obstruction}px`;
      topButton.style.bottom = `${156 + obstruction}px`;
      topButton.style.display = scrollY > 700 ? 'block' : 'none';
    });
  }
  function readPage(root, fallbackPage) {
    const data = $('#wfd-eb-page-data', root);
    const nav = $('.pagination-wrapper', root);
    const page = Number(data?.dataset.currentPage || $('.pagination__item--current', root)?.textContent.trim() || fallbackPage);
    const next = data ? data.dataset.nextUrl : $('.pagination__item--prev[href]', root)?.getAttribute('href');
    return { data, nav, page, next: next || '' };
  }
  function updateStatus() {
    if (!controls) return;
    loadButton.disabled = !!request || !nextUrl;
    loadButton.hidden = !nextUrl;
    loadButton.textContent = error ? labels.retry : labels.load_more;
    controls.setAttribute('aria-busy', String(!!request));
    const range = firstPage === currentPage ? String(currentPage) : `${firstPage}–${currentPage}`;
    status.textContent = request ? labels.loading : error ? labels.error : !nextUrl ? labels.end : labels.showing.replace('[pages]', range);
    autoLoadInput.checked = autoLoad;
  }
  function cancelRequest() {
    generation++;
    if (request) request.abort();
    request = null;
    observer?.disconnect();
    updateStatus();
  }
  function watchSentinel() {
    observer?.disconnect();
    if (!autoLoad || !nextUrl || error || restoring || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) loadNext();
    }, { rootMargin: '400px 0px', threshold: 0 });
    observer.observe(sentinel);
  }
  function productKey(item) {
    const link = $('a[id^="CardLink-"]', item) || $('a[href*="/products/"]', item);
    return link ? new URL(link.getAttribute('href'), location.href).pathname : null;
  }
  async function loadNext() {
    if (request || !nextUrl || !grid?.isConnected || $('.collection.loading', container)) return false;
    const capturedGrid = grid, capturedGeneration = generation, capturedSignature = signature;
    const url = new URL(nextUrl, location.href);
    const wantedPage = Number(url.searchParams.get('page'));
    if (url.origin !== location.origin || collectionSignature(url) !== collectionSignature(location.href) || wantedPage !== currentPage + 1) {
      error = true;
      observer?.disconnect();
      updateStatus();
      return false;
    }
    const sectionId = grid.dataset.id;
    if (sectionId) url.searchParams.set('section_id', sectionId);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const controller = new AbortController();
    request = controller;
    error = false;
    updateStatus();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url.toString(), { signal: controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Collection request failed');
      const html = await response.text();
      if (capturedGeneration !== generation || capturedGrid !== $('#product-grid', container) || capturedSignature !== urlSignature() || $('.collection.loading', container)) return false;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = $('#product-grid', parsed);
      const meta = readPage(parsed, wantedPage);
      if (!incoming || meta.page !== wantedPage) throw new Error('Unexpected collection page');
      const existing = new Set(Array.from(grid.children).map(productKey).filter(Boolean));
      const cards = Array.from(incoming.children).filter(item => item.matches('li.grid__item'));
      if (!cards.length) throw new Error('Missing collection products');
      const fragment = document.createDocumentFragment();
      let added = 0;
      cards.forEach(card => {
        const key = productKey(card);
        if (!key || existing.has(key)) return;
        existing.add(key);
        card.querySelectorAll('.scroll-trigger').forEach(element => element.classList.add('scroll-trigger--cancel'));
        card.classList.add('scroll-trigger--cancel');
        card.querySelectorAll('quick-add-modal').forEach(modal => gridModals.add(modal));
        fragment.append(card);
        added++;
      });
      if (!added) throw new Error('Repeated collection page');
      grid.append(fragment);
      currentPage = meta.page;
      nextUrl = meta.next;
      if (pageData && meta.data) {
        pageData.dataset.currentPage = String(currentPage);
        pageData.dataset.nextUrl = nextUrl;
      }
      if (pager && meta.nav) pager.replaceWith(meta.nav);
      else if (meta.nav) controls.before(meta.nav);
      pager = $('.pagination-wrapper', container);
      saveSpot();
      return true;
    } catch (_) {
      if (capturedGeneration === generation) {
        error = true;
        observer?.disconnect();
        stopScroll();
      }
      return false;
    } finally {
      clearTimeout(timeout);
      if (request === controller) {
        request = null;
        updateStatus();
        if (!error) watchSentinel();
      }
    }
  }
  function bindGrid() {
    const newGrid = $('#product-grid', container);
    if (newGrid === grid) return;
    cancelRequest();
    stopScroll();
    controls?.remove();
    modeControl?.remove();
    gridModals.forEach(modal => {
      if (modal.hasAttribute('open') && typeof modal.hide === 'function') modal.hide();
      modal.remove();
    });
    gridModals.clear();
    grid = newGrid;
    controls = null;
    if (!grid || !grid.matches('ul')) { scrollButton.hidden = true; return; }
    scrollButton.hidden = false;
    grid.querySelectorAll('modal-opener[data-modal]').forEach(opener => {
      const modal = document.getElementById(opener.dataset.modal.slice(1));
      if (modal?.matches('quick-add-modal')) gridModals.add(modal);
    });
    signature = urlSignature();
    const meta = readPage(container, Number(new URL(location.href).searchParams.get('page') || 1));
    currentPage = firstPage = meta.page;
    pageData = meta.data;
    pager = meta.nav;
    nextUrl = meta.next;
    error = false;
    controls = document.createElement('div');
    controls.id = 'wfd-eb-wrapper';
    const label = document.createElement('label');
    modeControl = document.createElement('div');
    modeControl.className = 'wfd-browse-mode';
    autoLoadInput = document.createElement('input');
    autoLoadInput.type = 'checkbox';
    autoLoadInput.checked = autoLoad;
    label.append(autoLoadInput, document.createTextNode(` ${labels.auto_load}`));
    autoLoadInput.addEventListener('change', () => {
      autoLoad = autoLoadInput.checked;
      storageSet('wfd_auto_load', autoLoad ? 'on' : 'off');
      watchSentinel();
    });
    modeControl.append(label);
    grid.before(modeControl);
    loadButton = makeButton('wfd-eb-load', labels.load_more);
    loadButton.className = 'button button--secondary';
    loadButton.addEventListener('click', loadNext);
    status = document.createElement('p');
    status.id = 'wfd-eb-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    sentinel = document.createElement('div');
    sentinel.id = 'wfd-eb-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    controls.append(loadButton, status, sentinel);
    (pager || grid).after(controls);
    updateStatus();
    watchSentinel();
  }
  function saveSpot() {
    if (!grid || restoring || signature !== urlSignature()) return;
    storageSet(`wfd_browse_v5:${signature}`, JSON.stringify({ page: currentPage, y: scrollY, time: Date.now() }));
  }
  async function restoreSpot() {
    if (performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
    let saved;
    try { saved = JSON.parse(storageGet(`wfd_browse_v5:${signature}`)); } catch (_) { return; }
    if (!saved || !Number.isInteger(saved.page) || saved.page < firstPage || !Number.isFinite(saved.y) || Date.now() - saved.time > 3600000) return;
    const capturedGeneration = generation;
    restoring = true;
    observer?.disconnect();
    try {
      while (currentPage < saved.page && nextUrl && !restoreCancelled && capturedGeneration === generation) {
        if (!await loadNext()) break;
      }
      if (!restoreCancelled && capturedGeneration === generation && currentPage >= saved.page) window.scrollTo({ top: saved.y, behavior: 'instant' });
    } finally {
      restoring = false;
      watchSentinel();
    }
  }
  document.addEventListener('input', event => {
    if (event.target.closest('facet-filters-form')) {
      saveSpot();
      cancelRequest();
      stopScroll();
      restoreCancelled = true;
    }
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('.js-facet-remove, facet-remove')) {
      saveSpot();
      cancelRequest();
      stopScroll();
      restoreCancelled = true;
    }
    if (event.target.closest('a[href*="/products/"], .pagination a[href]')) saveSpot();
  }, true);
  window.addEventListener('popstate', () => {
    stopScroll();
    restoreCancelled = true;
    if (urlSignature() !== signature) cancelRequest();
    else { updateStatus(); watchSentinel(); }
  });
  new MutationObserver(bindGrid).observe(container, { childList: true, subtree: true });
  let saveTimer;
  window.addEventListener('scroll', () => {
    positionButtons();
    clearTimeout(saveTimer);
    saveTimer = setTimeout(saveSpot, 200);
  }, { passive: true });
  window.addEventListener('resize', positionButtons, { passive: true });
  window.addEventListener('pagehide', () => { saveSpot(); stopScroll(); cancelRequest(); });
  window.addEventListener('pageshow', event => { if (event.persisted) { updateStatus(); watchSentinel(); } });
  restoring = true;
  bindGrid();
  restoring = false;
  restoreSpot().finally(watchSentinel);
  positionButtons();
})();
